import React, { Fragment } from "react";
import AbstractComponent from "../../AbstractComponent";
import { Tabs, Tab } from "react-bootstrap";

import Historia from "./institucional-assets/Historia";
import NossaHistoria from "./institucional-assets/NossaHistoria";
import Social from "./institucional-assets/Social";
import SocialMedia from "./institucional-assets/SocialMedia";
import Loja from "./institucional-assets/Loja";
import Link from "./institucional-assets/Link"

import InstitucionalService from '../../../service/InstitucionalService';
import AutenticarService from '../../../service/AutenticarService';

class Institucional extends AbstractComponent {
    constructor(props) {
    super(props);

    this.state = {
        form: {
            institucional: {
                historiaPrincipal : {},
                historiaSecundaria: [],
                socialPrincipal: {},
                social: [],
                socialGooglePlay: {},
                carrossel: [],
                enderecoLoja: [],
                oferta: {},
                compre_online: {}
            }
        }
    }
    }

    onChangeForPropsHistoria(e) {
        let form = this.state.form;
        let institucional = form.institucional;
        let historia = institucional.historiaPrincipal;

        historia[e.target.name] = e.target.value;

        institucional.historiaPrincipal = historia;
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }

    onChangeForPropsNossaHistoria(lista) {
        let form = this.state.form;
        let institucional = form.institucional;
        let nossaHistoria = institucional.historiaSecundaria;

        nossaHistoria = lista;

        institucional.historiaSecundaria = nossaHistoria;        
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }

    onChangeForPropsSocialPrincipal(e) {
        let form = this.state.form;
        let institucional = form.institucional;
        let socialPrincipal = institucional.socialPrincipal;

        socialPrincipal[e.target.name] = e.target.value;

        institucional.socialPrincipal = socialPrincipal;
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }

    onChangeForPropsSocial(lista) {
        let form = this.state.form;
        let institucional = form.institucional;
        let social = institucional.social;

        social = lista;

        institucional.social = social;        
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }


    onChangeForPropsLojas(lista) {
        let form = this.state.form;
        let institucional = form.institucional;
        let enderecoLoja = institucional.enderecoLoja;

        enderecoLoja = lista;

        institucional.enderecoLoja = enderecoLoja;        
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }

    onChangeForPropsLinkOferta(e) {
        let form = this.state.form;
        let institucional = form.institucional;
        let oferta = institucional.oferta;

        oferta[e.target.name] = e.target.value;

        institucional.oferta = oferta;
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }

    onChangeForPropsLinkCompreOnline(e) {
        let form = this.state.form;
        let institucional = form.institucional;
        let compre_online = institucional.compre_online;

        compre_online[e.target.name] = e.target.value;

        institucional.compre_online = compre_online;
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }

    onChangeForPropsLinkSocialGooglePlay(e) {
        let form = this.state.form;
        let institucional = form.institucional;
        let socialGooglePlay = institucional.socialGooglePlay;

        socialGooglePlay[e.target.name] = e.target.value;

        institucional.socialGooglePlay = socialGooglePlay;
        form.institucional = institucional;

        this.setState({
            form: form
        });
        this.props.onChange(form.institucional);
    }


    componentDidMount() {     
        InstitucionalService.get(
            AutenticarService.getIdEmpresa()
        ).then(response => {
            let form = this.state.form;
            form.institucional = response.data.institucional;
            this.setState({form: form})
        }) 
    }

    render() {
        return (
        <Fragment>
            <Tabs defaultActiveKey="historiaPrincipal" id="uncontrolled-tab-example" className="mb-3">

                <Tab eventKey="historiaPrincipal" title="Historia Principal">
                    <Historia 
                        historia={this.state.form.institucional.historiaPrincipal}
                        onChangeForPropsHistoria= {(e) => this.onChangeForPropsHistoria(e)}
                    />
                </Tab>
                <Tab eventKey="nossaHistoria" title="Nossa Historia">
                    <NossaHistoria 
                        nossaHistoria={this.state.form.institucional.historiaSecundaria}
                        onChangeForPropsNossaHistoria={(lista) => this.onChangeForPropsNossaHistoria(lista)}
                    />
                </Tab>

                <Tab eventKey="social" title="Redes Sociais">
                    <Social 
                        socialPrincipal={this.state.form.institucional.socialPrincipal}
                        onChangeForPropsSocialPrincipal= {(e) => this.onChangeForPropsSocialPrincipal(e)}
                    />   
                    <SocialMedia 
                        social={this.state.form.institucional.social}
                        onChangeForPropsSocial={(lista) => this.onChangeForPropsSocial(lista)}
                    />                 
                </Tab>

                <Tab eventKey="lojas" title="Lojas">
                    <Loja 
                        loja={this.state.form.institucional.enderecoLoja}
                        onChangeForPropsLojas= {(lista => this.onChangeForPropsLojas(lista))}
                    />
                </Tab>

                <Tab eventKey="links" title="Links">
                    <Link 
                        oferta={this.state.form.institucional.oferta}
                        onChangeForPropsLinkOferta= {(e) => this.onChangeForPropsLinkOferta(e)}
                        compre_online={this.state.form.institucional.compre_online}
                        onChangeForPropsLinkCompreOnline= {(e) => this.onChangeForPropsLinkCompreOnline(e)}
                        socialGooglePlay={this.state.form.institucional.socialGooglePlay}
                        onChangeForPropsLinkSocialGooglePlay= {(e) => this.onChangeForPropsLinkSocialGooglePlay(e)}
                    />
                </Tab>

            </Tabs>
        </Fragment>
        );
    }
}

export default Institucional;
